import template from './scoresheet_signature.html'
import './scoresheet_signature.css'

export default {
  template,
  controller: 'scoresheetSignatureController as scoresheetSignature'
}
